import React from 'react';
import { Container, Spinner, Title, Description, BoldText } from './styles';

const BlockedMessage = () => {
  return (
    <Container>
      <Spinner />
      <Title>Changes in progress</Title>
      <Description>
        Remember that you cannot make any other change until the menu is
        updated. You will receive a notification when changes are made. We are
        working <BoldText>Superorder</BoldText>.
      </Description>
    </Container>
  );
};

export default BlockedMessage;
